<template>
  <div class="content">
    <div class="mask" v-show="maskShow"></div>
    <div class="banner">
      <img src="../../img/mobile/Banner.png" />
    </div>
    <div class="info">
      <div class="userName user">
        <span class="nameTitle">员工姓名</span>
        <span class="name">{{userName}}</span>
      </div>
      <div class="border" style="position:relative;top:0.7rem;"></div>
      <div class="userNumber user">
        <span class="numberTitle">员工工号</span>
        <span class="number">{{employeeCode}}</span>
      </div>
      <div class="border" style="position:relative;top:1.7rem;"></div>
      <div class="userPhone user">
        <span class="phoneTitle">当前手机号</span>
        <span class="phone">{{currentPhone}}</span>
      </div>
      <div class="border" style="position:relative;top:2.7rem;"></div>
    </div>
    <button class="returnBtn" @click="goback()">返回</button>
    <button class="confirmBtn" @click="confirm()">确定</button>
    <tips :maskShow="maskShow" :employeeCode="employeeCode" :currentPhone="currentPhone"></tips>
  </div>
</template>

<script>
import tips from "../../components/mobile/tips";
export default {
  components: {
    tips
  },
  data() {
    return {
      maskShow: false,
      userName: "",
      employeeCode: "",
      currentPhone: ""
    };
  },
  methods: {
    goback() {
      this.$router.push(`/phoneNum?flag=0&&name=${this.userName}`);
    },
    confirm() {
      this.maskShow = !this.maskShow;
    }
  },
  mounted() {
    console.log(this.$route.query, "this.$route.query");
    this.userName = this.$route.query.userName;
    this.employeeCode = this.$route.query.employeeCode;
    this.currentPhone = this.$route.query.currentPhone;
  }
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 100%;
  .banner {
    height: 3.6rem;
    img {
      width: 7.5rem;
      height: 3.6rem;
    }
  }
  .mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: #000;
    opacity: 0.3;
  }
  .border {
    width: 6.9rem;
    height: 0.02rem;
    background: rgba(229, 229, 229, 1);
  }
  .info {
    width: 6.9rem;
    margin: 0.83rem 0.3rem;
    position: relative;
    display: flex;
    flex-direction: column;
    .user {
      height: 0.42rem;
      font-size: 0.3rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 0.42rem;
    }
    .userName {
      position: absolute;
      left: 0.3rem;
      .nameTitle {
        width: 2.5rem;
        color: rgba(102, 102, 102, 1);
        text-align: right;
        display: inline-block;
      }
      .name {
        color: rgba(51, 51, 51, 1);
        margin-left: 0.5rem;
      }
    }
    .userNumber {
      position: absolute;
      left: 0.3rem;
      top: 1rem;
      .numberTitle {
        width: 2.5rem;
        color: rgba(102, 102, 102, 1);
        text-align: right;
        display: inline-block;
      }
      .number {
        color: rgba(51, 51, 51, 1);
        margin-left: 0.5rem;
      }
    }
    .userPhone {
      position: absolute;
      left: 0.3rem;
      top: 2rem;
      .phoneTitle {
        width: 2.5rem;
        color: rgba(102, 102, 102, 1);
        text-align: right;
        display: inline-block;
      }
      .phone {
        color: rgba(51, 51, 51, 1);
        margin-left: 0.5rem;
      }
    }
  }
  button {
    width: 3.1rem;
    height: 0.88rem;
    border-radius: 0.04rem;
    border: none;
    outline: none;
    font-size: 0.32rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
  }
  .returnBtn {
    border: 0.02rem solid rgba(34, 142, 243, 1);
    position: relative;
    top: 3rem;
    background: none;
    color: rgba(34, 142, 243, 1);
  }
  .confirmBtn {
    background: rgba(34, 142, 243, 1);
    position: relative;
    top: 3rem;
    color: rgba(255, 255, 255, 1);
  }
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/userInfo.vue